module.exports = __webpack_public_path__ + "static/media/gray_animal_amphibians_5.f936d923.webp";